const styles = () => ({
  drawerRoot: {
    display: "flex",
    flex: 1,
    minHeight: 0,
    position: "relative" as const,
    overflow: "hidden",
  },
  hamburgerStrip: {
    position: "absolute" as const,
    top: 0,
    left: 0,
    bottom: 0,
    width: 40,
    zIndex: 1,
    display: "flex",
    alignItems: "flex-start",
    paddingTop: "4px",
    backgroundColor: "rgb(242, 242, 242)",
    borderRight: "1px solid rgba(0,0,0,0.12)",
  },
  hamburgerButton: {
    outline: "0 !important",
    color: "#000000",
  },
  closeButton: {
    outline: "0 !important",
  },
});

export default styles;
